export default __webpack_public_path__ + "1a1bc6c425ca8dc1a128f89fa45603a0.woff2";